import React, { useEffect, useState } from "react";
import { Container, Row, Col, Breadcrumb, BreadcrumbItem, Card, CardBody, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { Link, useLocation } from "react-router-dom";
import { Home } from "react-feather";

import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";

import { KIBANA_JP_URL, KIBANA_JP_INTERNAL_URL } from "../../Common/KibanaAPIEndpoints/KibanaAPIEndpoints";

import { useKibanaAuthentication } from "../../hooks/useKibanaAuthentication";

export default function JobspikrRequestLogs() {

  const { setToken } = useKibanaAuthentication();

  const [mainLoading, setMainLoading] = useState(true)

  useEffect(() => {
    setSearchParamsData();
    async function fetchInitialData() {
      try {
        setMainLoading(true);
        await setToken(KIBANA_JP_URL)
      } catch (err) {
        console.error("Failed to fetch data", err);
      } finally {
        setMainLoading(false);
      }
    }

    fetchInitialData();
  }, []);

  function KibanaUrl(kibana_url){
    return `${kibana_url}app/kibana#/dashboard/Jobspikr-Logstash?_g=()&_a=(description:'',filters:!(),fullScreenMode:!f,options:(darkTheme:!f),panels:!((embeddableConfig:(columns:!(method,status,route,duration,format,host,path),sort:!('@timestamp',desc)),gridData:(h:12,i:'1',w:48,x:0,y:12),id:Jobspikr-Request-Logs,panelIndex:'1',type:search,version:'7.5.1'),(embeddableConfig:(columns:!(method,route,error),sort:!('@timestamp',desc)),gridData:(h:12,i:'2',w:24,x:24,y:0),id:Jobspikr-Exception-Logs,panelIndex:'2',type:search,version:'7.5.1'),(embeddableConfig:(),gridData:(h:12,i:'3',w:24,x:0,y:0),id:Jobspikr-Request-Status-Graph,panelIndex:'3',type:visualization,version:'7.5.1')),query:(language:lucene,query:'*'),timeRestore:!f,title:'Jobspikr+Logstash',viewMode:view)`
  }

  if (mainLoading) {
    return (
      <Loader type="Puff" color="#00BFFF" height={100} width={100} className='pc-loader' />
    )
  }

  return <Container fluid>
    <div className="page-title">
      <Row className=''>
        <Col xs="6">
          <h3>Internal Dashboard</h3>
        </Col>
        <Col xs="6">
          <Breadcrumb>
            <BreadcrumbItem>
              <Link to={'/internal'}>
                <Home />
              </Link>
            </BreadcrumbItem>
            <BreadcrumbItem>Jobspikr Request Logs</BreadcrumbItem>
        </Breadcrumb>
      </Col>
    </Row>
  </div>

  <Card>
    <CardBody>
      <center>
        <a target="_blank" className="link-primary" href={KibanaUrl(KIBANA_JP_INTERNAL_URL)}>Click here to see below graph in kibana</a>
      </center>
      <iframe src={KibanaUrl(KIBANA_JP_URL) + "&embed=true"} height="500" width="100%" className="border-0"></iframe>
    </CardBody>
  </Card>
</Container>
}

